<template>
  <div id="app-root">
    <HeaderNE @tabclick="update" @tabchange="update" />
    <div class="app-content" style="background-color: #008080; padding: 20px;">
      <ProjectsNE @close="projects_open = false" @toFront="projectsToFront" v-if="tab === 1 && projects_open" :class="[projectsFront ? 'front' : 'back']" />
      <ContactNE @close="contact_open = false" @toFront="contactToFront" v-if="contact_open" :class="[contactFront ? 'front' : 'back']" />
      <AboutNE
        @toFront="aboutToFront"
        @close="about_open = false"
        v-if="tab === 0 && about_open"
        :class="[aboutFront ? 'front' : 'back']"
      />
      <ProfileNE
        @toFront="profileToFront"
        @close="profile_open = false"
        v-if="tab === 0 && profile_open"
        :class="[profileFront ? 'front' : 'back']"
      />
      <router-view/>
    </div>

    <!-- Windows 98 Start Menu -->
    <StartMenu
      @open-about="openAbout"
      @open-profile="openProfile"
      @open-contact="openContact"
    />
  </div>
</template>

<script>
import AboutNE from "./views/AboutNE";
import ContactNE from "./views/ContactNE";
import ProjectsNE from "./views/ProjectsNE";
import HeaderNE from "./views/HeaderNE";
import ProfileNE from "./views/ProfileNE";
import StartMenu from "./views/StartMenu.vue";
import interact from "interactjs";

export default {
  name: "App",
  components: {
    AboutNE,
    ContactNE,
    ProjectsNE,
    HeaderNE,
    ProfileNE,
    StartMenu
  },
  data: () => ({
    tab: 0,
    about_open: true,
    projects_open: true,
    contact_open: true, // Show contact window on main page
    profile_open: true,
    aboutFront: true,
    profileFront: false,
    projectsFront: false,
    contactFront: false
  }),
  methods: {
    update(a) {
      this.tab = a;
      // Set appropriate component states based on tab
      if (a === 0) {
        this.about_open = true;
        this.profile_open = true;
        this.contact_open = true;
      } else if (a === 1) {
        this.projects_open = true;
      }
    },
    profileToFront() {
      this.profileFront = true;
      this.aboutFront = false;
      this.projectsFront = false;
      this.contactFront = false;
    },
    aboutToFront() {
      this.profileFront = false;
      this.aboutFront = true;
      this.projectsFront = false;
      this.contactFront = false;
    },
    projectsToFront() {
      this.profileFront = false;
      this.aboutFront = false;
      this.projectsFront = true;
      this.contactFront = false;
    },
    contactToFront() {
      this.profileFront = false;
      this.aboutFront = false;
      this.projectsFront = false;
      this.contactFront = true;
    },
    initInteract() {
      // Skip drag/resize on mobile — windows are stacked in flow layout instead
      if (window.innerWidth < 768) return;

      // Draggable functionality
      interact(".draggable").draggable({
        listeners: { move: window.dragMoveListener },
        inertia: false,
        modifiers: [
          interact.modifiers.restrictRect({
            restriction: "parent",
            endOnly: true
          })
        ]
      });

      // Native resize functionality - try multiple times to catch late-rendering components
      this.initResizeHandles();
    },
    
    initResizeHandles() {
      const resizableElements = document.querySelectorAll(".resizable");
      
      resizableElements.forEach((element) => {
        this.addResizeHandles(element);
      });
      
      // If we didn't find all expected elements, try again in a bit
      if (resizableElements.length < 3) {
        setTimeout(() => {
          this.initResizeHandles();
        }, 500);
      }
    },
    
    // Start Menu Methods
    openAbout() {
      // Ensure window is open and bring to front
      this.about_open = true;
      this.aboutToFront();
    },
    
    openProfile() {
      // Ensure window is open and bring to front
      this.profile_open = true;
      this.profileToFront();
    },
    
    openContact() {
      // Ensure window is open and bring to front
      this.contact_open = true;
      this.contactToFront();
    },
    
    addResizeHandles(element) {
      // Find the actual window content (.win-card) inside the wrapper
      const windowContent = element.querySelector('.win-card') || element;

      // Determine the target element for resize handle positioning
      let resizeTarget;
      if (element.classList.contains('resizable') && element.querySelector('.win-card')) {
        // Wrapper div case (AboutNE, ProfileNE)
        resizeTarget = element.querySelector('.win-card');
      } else if (element.classList.contains('resizable') && element.classList.contains('win-card')) {
        // Direct win-card case (ContactNE)
        resizeTarget = element;
      } else {
        // Fallback
        resizeTarget = element;
      }
      
      // Create resize handle and append it to the body to avoid drag conflicts
      const handle = document.createElement('div');
      handle.setAttribute('data-window-id', element.className + '-' + Math.random()); // Unique identifier
      handle.style.cssText = `
        position: fixed;
        width: 20px;
        height: 20px;
        cursor: se-resize;
        background: transparent;
        z-index: 10000;
        pointer-events: auto;
      `;
      
      // Position the handle relative to the window
      const updateHandlePosition = () => {
        const rect = resizeTarget.getBoundingClientRect();
        handle.style.left = (rect.right - 20) + 'px';
        handle.style.top = (rect.bottom - 20) + 'px';

      };
      
      // Initial position
      updateHandlePosition();
      
      // Add to body to avoid drag conflicts
      document.body.appendChild(handle);
      
      let isResizing = false;
      let startX, startY, startWidth, startHeight;
      
      handle.addEventListener('mousedown', (e) => {

        isResizing = true;
        startX = e.clientX;
        startY = e.clientY;
        startWidth = resizeTarget.offsetWidth;
        startHeight = resizeTarget.offsetHeight;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      });
      
      document.addEventListener('mousemove', (e) => {
        if (!isResizing) return;
        
        const deltaX = e.clientX - startX;
        const deltaY = e.clientY - startY;
        
        const newWidth = Math.max(200, startWidth + deltaX);
        const newHeight = Math.max(100, startHeight + deltaY);
        
        resizeTarget.style.width = newWidth + 'px';
        resizeTarget.style.height = newHeight + 'px';
        
        // Also resize the content container
        const contentContainer = resizeTarget.querySelector('.win-container, .contact-content');
        if (contentContainer) {
          contentContainer.style.width = '100%';
          contentContainer.style.height = 'auto';
          
          // Hide content when window is too small
          if (newWidth < 300 || newHeight < 150) {
            contentContainer.style.opacity = '0.3';
            contentContainer.style.pointerEvents = 'none';
          } else {
            contentContainer.style.opacity = '1';
            contentContainer.style.pointerEvents = 'auto';
          }
        }
        
        // Special handling for Contact window to ensure proper sizing
        if (resizeTarget.querySelector('.contact-content')) {
          const contactContent = resizeTarget.querySelector('.contact-content');
          if (newWidth < 350) {
            contactContent.style.padding = '8px';
          } else {
            contactContent.style.padding = '16px';
          }
          
          // Force the window to recalculate its height based on content
          windowContent.style.height = 'auto';
          setTimeout(() => {
            const newHeight = windowContent.scrollHeight;
            windowContent.style.height = newHeight + 'px';
          }, 10);
        }
        
        // Update handle position
        updateHandlePosition();
      });
      
      document.addEventListener('mouseup', () => {
        isResizing = false;

      });
      
      // Clean up handle when component is destroyed
      element.addEventListener('remove', () => {
        if (handle.parentNode) {
          handle.parentNode.removeChild(handle);
        }
      });
    }
  },
  mounted() {
    // Wait a bit for components to render
    setTimeout(() => {
      this.initInteract();
    }, 500); // Increased delay
  },
  updated() {
    // Reinitialize interact when components update
    this.$nextTick(() => {
      setTimeout(() => {
        this.initInteract();
      }, 200);
    });
  },
  
  // Also watch for route changes and component updates
  watch: {
    tab() {
      // Reinitialize when tab changes
      this.$nextTick(() => {
        setTimeout(() => {
          this.initInteract();
        }, 300);
      });
    }
  }
};

function dragMoveListener(event) {
  const target = event.target;
  // keep the dragged position in the data-x/data-y attributes
  const x = (parseFloat(target.getAttribute("data-x")) || 0) + event.dx;
  const y = (parseFloat(target.getAttribute("data-y")) || 0) + event.dy;

  // translate the element
  target.style.webkitTransform = target.style.transform =
    "translate(" + x + "px, " + y + "px)";
  // update the position attributes
  target.setAttribute("data-x", x);
  target.setAttribute("data-y", y);
}

// this function is used later in the resizing and gesture demos
window.dragMoveListener = dragMoveListener;

function resizeMoveListener(event) {
  const target = event.target;
  let x = (parseFloat(target.getAttribute('data-x')) || 0);
  let y = (parseFloat(target.getAttribute('data-y')) || 0);

  // update the element's style
  target.style.width = event.rect.width + 'px';
  target.style.height = event.rect.height + 'px';

  // translate when resizing from top or left edges
  x += event.deltaRect.left;
  y += event.deltaRect.top;

  target.style.transform = 'translate(' + x + 'px,' + y + 'px)';

  // update the posiion attributes
  target.setAttribute('data-x', x);
  target.setAttribute('data-y', y);
}

window.resizeMoveListener = resizeMoveListener;
</script>

<style>
/* Viewport-filling layout (previously handled by Vuetify's v-app) */
*, *::before, *::after {
  box-sizing: border-box;
}

html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  height: 100%;
}

#app-root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-content {
  flex: 1;
}

.draggable {
  touch-action: none;
}
.front {
  z-index: 9999
}
.back {
  z-index: 0
}

/* Windows 98 Style Scrollbars */
::-webkit-scrollbar {
  width: 16px;
  height: 16px;
}

::-webkit-scrollbar-track {
  background: #c0c0c0;
  border: 1px solid #808080;
}

::-webkit-scrollbar-thumb {
  background: #c0c0c0;
  border: 1px solid #808080;
  border-top: 1px solid #ffffff;
  border-left: 1px solid #ffffff;
}

::-webkit-scrollbar-thumb:hover {
  background: #a0a0a0;
}

::-webkit-scrollbar-corner {
  background: #c0c0c0;
  border: 1px solid #808080;
  border-top: 1px solid #ffffff;
  border-left: 1px solid #ffffff;
}

/* Firefox scrollbar styling */
* {
  scrollbar-width: auto;
  scrollbar-color: #c0c0c0 #808080;
}

/* Resize functionality */
.resizable {
  /* position: relative; */
}

/* Show resize cursor on edges */
.resizable {
  cursor: default;
}

.resizable:hover {
  cursor: se-resize;
}

/* Make content responsive to container size */
.resizable .win-card {
  overflow: hidden;
}

.resizable .win-container,
.resizable .contact-content {
  width: 100% !important;
  height: 100% !important;
  box-sizing: border-box;
  overflow: hidden;
}

.resizable .win-card > img {
  width: 100%;
  height: auto;
  max-height: 100%;
}

/* Make buttons and content responsive */
.resizable .win-btn,
.resizable button {
  max-width: 100%;
  word-wrap: break-word;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.resizable .win-row {
  width: 100%;
  margin: 0;
}

.resizable .win-col {
  padding: 8px;
  min-width: 0;
}

/* Hide content when window is too small */
.resizable .win-container {
  min-height: 0;
}

/* Window shadows and 3D effects */
.window {
  box-shadow: 
    2px 2px 0px rgba(0,0,0,0.3),
    inset 1px 1px 0px rgba(255,255,255,0.8),
    inset -1px -1px 0px rgba(0,0,0,0.2);
  border: 1px solid #808080;
}

/* Enhanced window styling */
.win-card.window {
  border: 2px solid;
  border-color: #ffffff #808080 #808080 #ffffff;
  box-shadow:
    2px 2px 0px rgba(0,0,0,0.3),
    inset 1px 1px 0px rgba(255,255,255,0.8),
    inset -1px -1px 0px rgba(0,0,0,0.2);
}

/* Window animations */
.window-enter-active, .window-leave-active {
  transition: all 0.3s ease;
}

.window-enter-from {
  opacity: 0;
  transform: scale(0.8) translateY(-20px);
}

.window-leave-to {
  opacity: 0;
  transform: scale(0.8) translateY(20px);
}

/* Minimize/maximize animations */
.window-content-enter-active, .window-content-leave-active {
  transition: all 0.2s ease;
}

.window-content-enter-from, .window-content-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* ── Mobile layout ────────────────────────────────────────────── */
@media (max-width: 767px) {
  /* Shrink the decorative header */
  .header-bar {
    height: 150px !important;
    overflow: hidden;
  }

  /* Stack windows vertically in normal flow */
  .app-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 8px !important;
  }

  /* Reset absolute/fixed positioning so windows flow naturally */
  .draggable {
    position: static !important;
    transform: none !important;
    touch-action: auto !important;
    width: 100%;
  }

  /* Full-width windows */
  .draggable > .win-card,
  .win-card.draggable {
    width: 100% !important;
    position: static !important;
    left: auto !important;
    top: auto !important;
    box-sizing: border-box;
  }

  /* Thinner scrollbars on mobile */
  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
}
</style>
